import React, { useContext, useEffect, useState } from "react";
import { eResultCode, eUSER_FORM_TYPE } from "../../utils/enum";
import Text, { LanguageContext } from "../../context/language-context";
import { Col, Row, Table, TableProps, Typography } from "antd";
import { stringDateInLanguage } from "../../utils/helperFunctions";
import { getTimeline } from "../../utils/api.constant";
import useFetch from "../../hooks/useFetch";

type CustomGuidelineProps = {
  userType?: number;
};

const DashboardGuideline: React.FC<CustomGuidelineProps> = ({ userType }) => {
  const { post } = useFetch();
  const [timeLine, setTimeLine] = useState<any>([]);
  const { userLanguage, userLanguageChange } = useContext(LanguageContext);

  interface DataType {
    key: string;
    ved: string;
    level_one: string;
    level_two: string;
  }
  interface TeacherGuidelineTable {
    key: string;
    ved: string;
    level_one: string;
    level_two: string;
  }

  const studentGuideLineColumns: TableProps<DataType>["columns"] = [
    {
      title: Text({ tid: "VED", def: "VED" }),
      dataIndex: "ved",
      key: "ved",
      width: "15%",
    },
    {
      title: Text({
        tid: "STUDENT_GUIDELINE_TABLE_LEVEL_1",
        def: "STUDENT_GUIDELINE_TABLE_LEVEL_1",
      }),
      dataIndex: "level_one",
      key: "level_one",
    },
    {
      title: Text({
        tid: "STUDENT_GUIDELINE_TABLE_LEVEL_2",
        def: "STUDENT_GUIDELINE_TABLE_LEVEL_2",
      }),
      dataIndex: "level_two",
      key: "level_two",
    },
  ];
  const teacherGuideLineColumns: TableProps<TeacherGuidelineTable>["columns"] =
    [
      {
        title: Text({ tid: "VED", def: "VED" }),
        dataIndex: "ved",
        key: "ved",
        width: "15%",
      },
      {
        title: Text({
          tid: "TEACHER_GUIDELINE_TABLE_LEVEL_1",
          def: "TEACHER_GUIDELINE_TABLE_LEVEL_1",
        }),
        dataIndex: "level_one",
        key: "level_one",
      },
      {
        title: Text({
          tid: "TEACHER_GUIDELINE_TABLE_LEVEL_2",
          def: "TEACHER_GUIDELINE_TABLE_LEVEL_2",
        }),
        dataIndex: "level_two",
        key: "level_two",
      },
    ];

  const studentGuideLineData: DataType[] = [
    {
      key: "1",
      ved: Text({ tid: "RIGVEDA", def: "RIGVEDA" }),
      level_one: Text({
        tid: "STUDENT_RIGVEDA_LEVEL_1",
        def: "STUDENT_RIGVEDA_LEVEL_1",
      }),
      level_two: Text({
        tid: "STUDENT_RIGVEDA_LEVEL_2",
        def: "STUDENT_RIGVEDA_LEVEL_2",
      }),
    },
    {
      key: "2",
      ved: Text({ tid: "KRISHNA_YAJURVEDA", def: "KRISHNA_YAJURVEDA" }),
      level_one: Text({
        tid: "STUDENT_KRISHNA_YAJURVEDA_LEVEL_1",
        def: "STUDENT_KRISHNA_YAJURVEDA_LEVEL_1",
      }),
      level_two: Text({
        tid: "STUDENT_KRISHNA_YAJURVEDA_LEVEL_2",
        def: "STUDENT_KRISHNA_YAJURVEDA_LEVEL_2",
      }),
    },
    {
      key: "3",
      ved: Text({ tid: "SHUKLA_YAJURVEDA", def: "SHUKLA_YAJURVEDA" }),
      level_one: Text({
        tid: "STUDENT_SHUKLA_YAJURVEDA_LEVEL_1",
        def: "STUDENT_SHUKLA_YAJURVEDA_LEVEL_1",
      }),
      level_two: Text({
        tid: "STUDENT_SHUKLA_YAJURVEDA_LEVEL_2",
        def: "STUDENT_SHUKLA_YAJURVEDA_LEVEL_2",
      }),
    },
    {
      key: "4",
      ved: Text({ tid: "SAMAVEDA", def: "SAMAVEDA" }),
      level_one: Text({
        tid: "STUDENT_2026_SAMADEVA_LEVEL_1",
        def: "STUDENT_2026_SAMADEVA_LEVEL_1",
      }),
      level_two: Text({
        tid: "STUDENT_2026_SAMAVEDA_LEVEL_2",
        def: "STUDENT_2026_SAMAVEDA_LEVEL_2",
      }),
    },
    {
      key: "5",
      ved: Text({ tid: "ATHARVAVEDA", def: "ATHARVAVEDA" }),
      level_one: Text({
        tid: "STUDENT_2026_ATHARVAVEDA_LEVEL_1",
        def: "STUDENT_2026_ATHARVAVEDA_LEVEL_1",
      }),
      level_two: Text({
        tid: "STUDENT_2026_ATHARVAVEDA_LEVEL_2",
        def: "STUDENT_2026_ATHARVAVEDA_LEVEL_2",
      }),
    },
  ];
  const teacherGuideLineData: TeacherGuidelineTable[] = [
    {
      key: "1",
      ved: Text({ tid: "RIGVEDA", def: "RIGVEDA" }),
      level_one: Text({
        tid: "TEACHER_RIGVEDA_LEVEL_1",
        def: "TEACHER_RIGVEDA_LEVEL_1",
      }),
      level_two: Text({
        tid: "TEACHER_RIGVEDA_LEVEL_2",
        def: "TEACHER_RIGVEDA_LEVEL_2",
      }),
    },
    {
      key: "2",
      ved: Text({ tid: "KRISHNA_YAJURVEDA", def: "KRISHNA_YAJURVEDA" }),
      level_one: Text({
        tid: "TEACHER_KRISHNA_YAJURVEDA_LEVEL_1",
        def: "TEACHER_KRISHNA_YAJURVEDA_LEVEL_1",
      }),
      level_two: Text({
        tid: "TEACHER_KRISHNA_YAJURVEDA_LEVEL_2",
        def: "TEACHER_KRISHNA_YAJURVEDA_LEVEL_2",
      }),
    },
    {
      key: "3",
      ved: Text({ tid: "SHUKLA_YAJURVEDA", def: "SHUKLA_YAJURVEDA" }),
      level_one: Text({
        tid: "TEACHER_SHUKLA_YAJURVEDA_LEVEL_1",
        def: "TEACHER_SHUKLA_YAJURVEDA_LEVEL_1",
      }),
      level_two: Text({
        tid: "TEACHER_SHUKLA_YAJURVEDA_LEVEL_2",
        def: "TEACHER_SHUKLA_YAJURVEDA_LEVEL_2",
      }),
    },
    {
      key: "4",
      ved: Text({ tid: "SAMAVEDA", def: "SAMAVEDA" }),
      level_one: Text({
        tid: "TEACHER_2026_SAMAVEDA_LEVEL_1",
        def: "TEACHER_2026_SAMAVEDA_LEVEL_1",
      }),
      level_two: Text({
        tid: "TEACHER_2026_SAMAVEDA_LEVEL_2",
        def: "TEACHER_2026_SAMAVEDA_LEVEL_2",
      }),
    },
    {
      key: "5",
      ved: Text({ tid: "ATHARVAVEDA", def: "ATHARVAVEDA" }),
      level_one: Text({
        tid: "TEACHER_2026_ATHARVAVEDA_LEVEL_1",
        def: "TEACHER_2026_ATHARVAVEDA_LEVEL_1",
      }),
      level_two: Text({
        tid: "TEACHER_2026_ATHARVAVEDA_LEVEL_2",
        def: "TEACHER_2026_ATHARVAVEDA_LEVEL_2",
      }),
    },
  ];

  const APPLICATION_WINDOW_STUDENT_PART1 = `
    ${Text({ tid: "STUDENT_APPLICATION_WINDOW_PART1_FROM", def: "STUDENT_APPLICATION_WINDOW_PART1_FROM" })}
    &nbsp;${stringDateInLanguage("2026-03-01")}&nbsp;
    ${Text({ tid: "STUDENT_APPLICATION_WINDOW_PART1_TO", def: "STUDENT_APPLICATION_WINDOW_PART1_TO" })}
    &nbsp;${stringDateInLanguage(
      userLanguage === "en" ? "2026-04-30" : "2026-06-30",
    )}&nbsp;
    ${Text({ tid: "STUDENT_APPLICATION_WINDOW_PART_END", def: "" })}
  `;
  const APPLICATION_WINDOW_TEACHER_PART1 = `
    ${Text({ tid: "TEACHER_APPLICATION_WINDOW_PART1_FROM", def: "TEACHER_APPLICATION_WINDOW_PART1_FROM" })}
    &nbsp;${stringDateInLanguage(timeLine[0]?.startDate)}&nbsp;
    ${Text({ tid: "TEACHER_APPLICATION_WINDOW_PART1_TO", def: "TEACHER_APPLICATION_WINDOW_PART1_TO" })}
    &nbsp;${stringDateInLanguage(
      userLanguage === "en" || userLanguage === "sk"
        ? "2026-06-30"
        : "2026-04-30",
    )}&nbsp;
    ${Text({ tid: "TEACHER_APPLICATION_WINDOW_PART_END", def: "" })}
  `;
  const APPLICATION_WINDOW_SCHOOL_PART1 = `
    ${Text({ tid: "SCHOOL_APPLICATION_WINDOW_PART1_FROM", def: "SCHOOL_APPLICATION_WINDOW_PART1_FROM" })}
    &nbsp;${stringDateInLanguage(
      userLanguage === "en" ? "2026-03-01" : timeLine[0]?.startDate,
    )}&nbsp;
    ${Text({ tid: "SCHOOL_APPLICATION_WINDOW_PART1_TO", def: "SCHOOL_APPLICATION_WINDOW_PART1_TO" })}
    &nbsp;${stringDateInLanguage(
      userLanguage === "en" ? "2026-06-30" : timeLine[0]?.endDate,
    )}&nbsp;
    ${Text({ tid: "SCHOOL_APPLICATION_WINDOW_PART_END", def: "" })}
  `;

  const APPLICATION_WINDOW_STUDENT_PART2 = `
    ${Text({ tid: "STUDENT_APPLICATION_WINDOW_PART2_FROM", def: "STUDENT_APPLICATION_WINDOW_PART2_FROM" })}
    &nbsp;${stringDateInLanguage("2026-04-01")}&nbsp;
    ${Text({ tid: "STUDENT_APPLICATION_WINDOW_PART2_TO", def: "STUDENT_APPLICATION_WINDOW_PART2_TO" })}
    &nbsp;${stringDateInLanguage("2026-06-30")}&nbsp;
    ${Text({ tid: "STUDENT_APPLICATION_WINDOW_PART_END", def: "" })}
  `;
  const APPLICATION_WINDOW_TEACHER_PART2 = `
    ${Text({ tid: "TEACHER_APPLICATION_WINDOW_PART2_FROM", def: "TEACHER_APPLICATION_WINDOW_PART2_FROM" })}
    &nbsp;${stringDateInLanguage("2026-04-01")}&nbsp;
    ${Text({ tid: "TEACHER_APPLICATION_WINDOW_PART2_TO", def: "TEACHER_APPLICATION_WINDOW_PART2_TO" })}
    &nbsp;${stringDateInLanguage("2026-06-30")}&nbsp;
    ${Text({ tid: "TEACHER_APPLICATION_WINDOW_PART_END", def: "" })}
  `;
  const APPLICATION_WINDOW_SCHOOL_PART2 = `
    ${Text({ tid: "SCHOOL_APPLICATION_WINDOW_PART2_FROM", def: "SCHOOL_APPLICATION_WINDOW_PART2_FROM" })}
    &nbsp;${stringDateInLanguage(
      userLanguage === "en" ? "2026-04-01" : timeLine[1]?.startDate,
    )}&nbsp;
    ${Text({ tid: "SCHOOL_APPLICATION_WINDOW_PART2_TO", def: "SCHOOL_APPLICATION_WINDOW_PART2_TO" })}
    &nbsp;${stringDateInLanguage(
      userLanguage === "en" ? "2026-06-30" : timeLine[1]?.endDate,
    )}&nbsp;
    ${Text({ tid: "SCHOOL_APPLICATION_WINDOW_PART_END", def: "" })}
  `;

  const SPECIAL_INSTRUCTION_6_ONLINE_TEACHER = `
    ${Text({ tid: "TEACHER_SPECIAL_INSTRUCTION_6_ONLINE", def: "TEACHER_SPECIAL_INSTRUCTION_6_ONLINE" })}
    &nbsp;<a href="https://bharatatmapuraskar.org" class="text-primary">www.bharatatmapuraskar.org</a>
  `;
  const SPECIAL_INSTRUCTION_6_ONLINE_SCHOOL = `
  ${Text({ tid: "SCHOOL_SPECIAL_INSTRUCTION_6_ONLINE", def: "SCHOOL_SPECIAL_INSTRUCTION_6_ONLINE" })}
  &nbsp;<a href="https://bharatatmapuraskar.org" class="text-primary">www.bharatatmapuraskar.org</a>
`;

  const SPECIAL_INSTRUCTION_6_OFFLINE_EMAIL_CONTENT = `<b>${Text({
    tid: "STUDENT_SPECIAL_INSTRUCTION_6_OFFLINE_EMAIL",
    def: "STUDENT_SPECIAL_INSTRUCTION_6_OFFLINE_EMAIL",
  })}</b>
    <a href="mailto:applications@bharatatmapuraskar.org" class="text-primary">
      applications@bharatatmapuraskar.org&nbsp;
    </a>

  `;

  const SPECIAL_INSTRUCTION_6_OFFLINE_EMAIL_CONTENT_POST_COURIER = `<b>
    ${Text({ tid: "STUDENT_SPECIAL_INSTRUCTION_6_OFFLINE_EMAIL_CONTENT_POST_COURIER", def: "STUDENT_SPECIAL_INSTRUCTION_6_OFFLINE_EMAIL_CONTENT_POST_COURIER" })}</b>
    ${Text({ tid: "STUDENT_SPECIAL_INSTRUCTION_6_OFFLINE_EMAIL_CONTENT_POST_COURIER_CONTENT", def: "STUDENT_SPECIAL_INSTRUCTION_6_OFFLINE_EMAIL_CONTENT_POST_COURIER_CONTENT" })}
  `;

  const SPECIAL_INSTRUCTION_6_OFFLINE_MOBILE = `<b>
    ${Text({ tid: "STUDENT_SPECIAL_INSTRUCTION_6_OFFLINE_MOBILE", def: "STUDENT_SPECIAL_INSTRUCTION_6_OFFLINE_MOBILE" })}</b>
    <a href="tel:+917357658777" class="text-primary">
      +91 73576 58777
    </a>`;

  const getTimelineData = async () => {
    try {
      const response = await post(getTimeline, {});
      const { dataResponse, data } = response;
      const { returnCode } = dataResponse;
      if (returnCode === eResultCode.SUCCESS) {
        setTimeLine(data);
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    getTimelineData();
  }, []);

  return (
    <div className="dashboardGuidelineComponent">
      {userType === eUSER_FORM_TYPE.STUDENT ? (
        <div>
          <div className=" mb-30">
            {/* Award Title and Guideline Heading */}
            <Row>
              <Col>
                <Typography.Title level={2}>
                  {Text({
                    tid: "STUDENT_AWARD_TITLE",
                    def: "STUDENT_AWARD_TITLE",
                  })}
                </Typography.Title>
                <Typography.Title level={3}>
                  {Text({
                    tid: "STUDENT_GUIDELINES_HEADING",
                    def: "STUDENT_GUIDELINES_HEADING",
                  })}
                </Typography.Title>
              </Col>
            </Row>
            {timeLine[0]?.startDate &&
              timeLine[0]?.endDate &&
              timeLine[1]?.startDate &&
              timeLine[1]?.endDate && (
                <Row className="section">
                  <Col>
                    <Typography.Title level={4}>
                      {Text({
                        tid: "STUDENT_APPLICATION_WINDOW",
                        def: "STUDENT_APPLICATION_WINDOW",
                      })}
                    </Typography.Title>
                    <ul>
                      {timeLine[0]?.startDate && timeLine[0]?.endDate && (
                        <li>
                          <div
                            dangerouslySetInnerHTML={{
                              __html: APPLICATION_WINDOW_STUDENT_PART1,
                            }}
                          ></div>
                        </li>
                      )}
                      <li>
                        {timeLine[1]?.startDate && timeLine[1]?.endDate && (
                          <div
                            dangerouslySetInnerHTML={{
                              __html: APPLICATION_WINDOW_STUDENT_PART2,
                            }}
                          ></div>
                        )}
                      </li>
                    </ul>
                  </Col>
                </Row>
              )}

            {/* INSTRUCTION_NOTE */}
            <Row className="section">
              <Col>
                <Typography.Title level={4}>
                  {Text({
                    tid: "STUDENT_2026_INSTRUCTION_NOTE_HEADING",
                    def: "STUDENT_2026_INSTRUCTION_NOTE_HEADING",
                  })}
                </Typography.Title>
                <ol
                  style={{
                    listStyleType:
                      userLanguage === "hi" || userLanguage === "sk"
                        ? "devanagari"
                        : "decimal",
                  }}
                >
                  <li>
                    <Typography.Text>
                      {Text({
                        tid: "STUDENT_2026_INSTRUCTION_NOTE_1",
                        def: "STUDENT_2026_INSTRUCTION_NOTE_1",
                      })}
                    </Typography.Text>
                  </li>
                  <li>
                    <Typography.Text>
                      {Text({
                        tid: "STUDENT_2026_INSTRUCTION_NOTE_2",
                        def: "STUDENT_2026_INSTRUCTION_NOTE_2",
                      })}
                    </Typography.Text>
                  </li>
                  <li>
                    <Typography.Text>
                      {Text({
                        tid: "STUDENT_2026_INSTRUCTION_NOTE_3",
                        def: "STUDENT_2026_INSTRUCTION_NOTE_3",
                      })}
                    </Typography.Text>
                  </li>
                  <li>
                    <Typography.Text>
                      {Text({
                        tid: "STUDENT_INSTRUCTION_NOTE_4",
                        def: "STUDENT_INSTRUCTION_NOTE_4",
                      })}
                    </Typography.Text>
                  </li>
                </ol>
              </Col>
            </Row>
            {/* ELIGIBILITY CRITERIA*/}
            <Row className="section">
              <Col>
                <Typography.Title level={4}>
                  {Text({
                    tid: "STUDENT_2026_ELIGIBILITY_CRITERIA_HEADING",
                    def: "STUDENT_2026_ELIGIBILITY_CRITERIA_HEADING",
                  })}
                </Typography.Title>
                <Typography.Text>
                  {Text({
                    tid: "STUDENT_2026_ELIGIBILITY_CRITERIA",
                    def: "STUDENT_2026_ELIGIBILITY_CRITERIA",
                  })}
                </Typography.Text>
                <ol
                  style={{
                    listStyleType:
                      userLanguage === "hi" || userLanguage === "sk"
                        ? "devanagari"
                        : "decimal",
                  }}
                >
                  <li>
                    <Typography.Text>
                      <b>
                        {Text({
                          tid: "STUDENT_2026_ELIGIBILITY_CRITERIA_1_TABLE_NOTE",
                          def: "STUDENT_2026_ELIGIBILITY_CRITERIA_1_TABLE_NOTE",
                        })}
                      </b>
                      {Text({
                        tid: "STUDENT_2026_ELIGIBILITY_CRITERIA_1",
                        def: "STUDENT_2026_ELIGIBILITY_CRITERIA_1",
                      })}
                      <div className="mobileGuidelineTable">
                        <Table
                          columns={studentGuideLineColumns}
                          dataSource={studentGuideLineData}
                          style={{
                            marginBottom: "10px",
                            overflowX: "auto",
                            paddingLeft: "0px",
                          }}
                          pagination={false}
                        />
                      </div>
                    </Typography.Text>
                  </li>
                  <li>
                    <Typography.Text>
                      <b>
                        {Text({
                          tid: "STUDENT_2026_ELIGIBILITY_CRITERIA_2_TABLE_NOTE",
                          def: "STUDENT_2026_ELIGIBILITY_CRITERIA_2_TABLE_NOTE",
                        })}
                      </b>
                      {Text({
                        tid: "STUDENT_2026_ELIGIBILITY_CRITERIA_2",
                        def: "STUDENT_2026_ELIGIBILITY_CRITERIA_2",
                      })}
                    </Typography.Text>
                  </li>
                  <li>
                    <Typography.Text>
                      <b>
                        {Text({
                          tid: "STUDENT_2026_ELIGIBILITY_CRITERIA_3_TABLE_NOTE",
                          def: "STUDENT_2026_ELIGIBILITY_CRITERIA_3_TABLE_NOTE",
                        })}
                      </b>
                      {Text({
                        tid: "STUDENT_2026_ELIGIBILITY_CRITERIA_3",
                        def: "STUDENT_2026_ELIGIBILITY_CRITERIA_3",
                      })}
                    </Typography.Text>
                    <li>
                      <Typography.Text>
                        <b>
                          {Text({
                            tid: "STUDENT_2026_ELIGIBILITY_CRITERIA_4_TABLE_NOTE",
                            def: "STUDENT_2026_ELIGIBILITY_CRITERIA_4_TABLE_NOTE",
                          })}
                        </b>
                        {Text({
                          tid: "STUDENT_2026_ELIGIBILITY_CRITERIA_4",
                          def: "STUDENT_2026_ELIGIBILITY_CRITERIA_4",
                        })}
                      </Typography.Text>
                    </li>
                  </li>

                  <li>
                    <Typography.Text>
                      <b>
                        {Text({
                          tid: "STUDENT_2026_ELIGIBILITY_CRITERIA_5_TABLE_NOTE",
                          def: "STUDENT_2026_ELIGIBILITY_CRITERIA_5_TABLE_NOTE",
                        })}
                      </b>
                      {Text({
                        tid: "STUDENT_2026_ELIGIBILITY_CRITERIA_5",
                        def: "STUDENT_2026_ELIGIBILITY_CRITERIA_5",
                      })}
                    </Typography.Text>
                  </li>
                </ol>
              </Col>
            </Row>
            {/* Special Instructions */}
            <Row className="section">
              <Col>
                <Typography.Title level={4}>
                  {Text({
                    tid: "STUDENT_2026_SPECIAL_INSTRUCTIONS_HEADING",
                    def: "STUDENT_2026_SPECIAL_INSTRUCTIONS_HEADING",
                  })}
                </Typography.Title>
                <ol
                  style={{
                    listStyleType:
                      userLanguage === "hi" || userLanguage === "sk"
                        ? "devanagari"
                        : "decimal",
                  }}
                >
                  <li>
                    <Typography.Text>
                      {Text({
                        tid: "STUDENT_2026_SPECIAL_INSTRUCTION_1",
                        def: "STUDENT_2026_SPECIAL_INSTRUCTION_1",
                      })}
                    </Typography.Text>
                  </li>
                  <li>
                    <Typography.Text>
                      {Text({
                        tid: "STUDENT_2026_SPECIAL_INSTRUCTION_2",
                        def: "STUDENT_2026_SPECIAL_INSTRUCTION_2",
                      })}
                    </Typography.Text>
                  </li>
                  <li>
                    <Typography.Text>
                      {Text({
                        tid: "STUDENT_2026_SPECIAL_INSTRUCTION_3",
                        def: "STUDENT_2026_SPECIAL_INSTRUCTION_3",
                      })}
                    </Typography.Text>
                  </li>
                  <li>
                    <Typography.Text>
                      {Text({
                        tid: "STUDENT_2026_SPECIAL_INSTRUCTION_4",
                        def: "STUDENT_2026_SPECIAL_INSTRUCTION_4",
                      })}
                    </Typography.Text>
                  </li>
                  <li>
                    <Typography.Text>
                      {Text({
                        tid: "STUDENT_2026_SPECIAL_INSTRUCTION_5",
                        def: "STUDENT_2026_SPECIAL_INSTRUCTION_5",
                      })}
                    </Typography.Text>
                  </li>
                  {/* <li>
                    <Typography.Text>
                      {Text({
                        tid: "STUDENT_SPECIAL_INSTRUCTION_7",
                        def: "STUDENT_SPECIAL_INSTRUCTION_7",
                      })}
                    </Typography.Text>
                  </li> */}
                  <li>
                    <Typography.Text>
                      {Text({
                        tid: "STUDENT_2026_SPECIAL_INSTRUCTION_6",
                        def: "STUDENT_2026_SPECIAL_INSTRUCTION_6",
                      })}
                    </Typography.Text>

                    <ul
                      className="guidelineAdditionalDetailSection mt-3 space-y-3"
                      style={{
                        listStyleType: "disc",
                        listStylePosition: "outside",
                        paddingLeft: "28px",
                      }}
                    >
                      <li className="leading-8">
                        <div
                          dangerouslySetInnerHTML={{
                            __html:
                              SPECIAL_INSTRUCTION_6_OFFLINE_EMAIL_CONTENT_POST_COURIER,
                          }}
                        />
                      </li>

                      <li className="leading-8">
                        <div
                          dangerouslySetInnerHTML={{
                            __html: SPECIAL_INSTRUCTION_6_OFFLINE_EMAIL_CONTENT,
                          }}
                        />
                      </li>

                      <li className="leading-8">
                        <div
                          dangerouslySetInnerHTML={{
                            __html: SPECIAL_INSTRUCTION_6_OFFLINE_MOBILE,
                          }}
                        />
                      </li>
                    </ul>
                  </li>
                  {/* <ul> */}
                  {/* <div className="guidelineAdditionalDetailSection">
                    <li className="flex flex-row justify-start items-start">
                      <div
                        dangerouslySetInnerHTML={{
                          __html:
                            SPECIAL_INSTRUCTION_6_OFFLINE_EMAIL_CONTENT_POST_COURIER,
                        }}
                      ></div>
                    </li>
                    <li className="flex flex-row justify-start items-start ">
                      <div
                        dangerouslySetInnerHTML={{
                          __html: SPECIAL_INSTRUCTION_6_OFFLINE_EMAIL_CONTENT,
                        }}
                      ></div>
                    </li>
                    <li className="flex flex-row justify-start items-start">
                      <div
                        dangerouslySetInnerHTML={{
                          __html: SPECIAL_INSTRUCTION_6_OFFLINE_MOBILE,
                        }}
                      ></div>
                    </li>
                  </div> */}
                  {/* </ul> */}
                </ol>
              </Col>
            </Row>
          </div>
        </div>
      ) : userType === eUSER_FORM_TYPE.SCHOOL ? (
        <div className=" mb-30">
          {/* Award Title and Guideline Heading */}
          <Row>
            <Col>
              <Typography.Title level={2}>
                {Text({
                  tid: "SCHOOL_AWARD_TITLE",
                  def: "SCHOOL_AWARD_TITLE",
                })}
              </Typography.Title>
              <Typography.Title level={3}>
                {Text({
                  tid: "SCHOOL_2026_GUIDELINES_HEADING",
                  def: "SCHOOL_2026_GUIDELINES_HEADING",
                })}
              </Typography.Title>
            </Col>
          </Row>
          {/* Application Window */}
          {timeLine[0]?.startDate &&
            timeLine[0]?.endDate &&
            timeLine[1]?.startDate &&
            timeLine[1]?.endDate && (
              <Row className="section">
                <Col>
                  <Typography.Title level={4}>
                    {Text({
                      tid: "SCHOOL_APPLICATION_WINDOW",
                      def: "SCHOOL_APPLICATION_WINDOW",
                    })}
                  </Typography.Title>
                  <ul>
                    <li>
                      <div
                        dangerouslySetInnerHTML={{
                          __html: APPLICATION_WINDOW_SCHOOL_PART1,
                        }}
                      ></div>
                    </li>
                    <li>
                      <div
                        dangerouslySetInnerHTML={{
                          __html: APPLICATION_WINDOW_SCHOOL_PART2,
                        }}
                      ></div>
                    </li>
                  </ul>
                </Col>
              </Row>
            )}
          {/* INSTRUCTION_NOTE */}
          <Row className="section">
            <Col>
              <Typography.Title level={4}>
                {Text({
                  tid: "SCHOOL_2026_INSTRUCTION_NOTE_HEADING",
                  def: "SCHOOL_2026_INSTRUCTION_NOTE_HEADING",
                })}
              </Typography.Title>
              <ol
                style={{
                  listStyleType:
                    userLanguage === "hi" || userLanguage === "sk"
                      ? "devanagari"
                      : "decimal",
                }}
              >
                <li>
                  <Typography.Text>
                    {Text({
                      tid: "SCHOOL_INSTRUCTION_NOTE_1",
                      def: "SCHOOL_INSTRUCTION_NOTE_1",
                    })}
                  </Typography.Text>
                </li>
                <li>
                  <Typography.Text>
                    {Text({
                      tid: "SCHOOL_INSTRUCTION_NOTE_2",
                      def: "SCHOOL_INSTRUCTION_NOTE_2",
                    })}
                  </Typography.Text>
                </li>
                <li>
                  <Typography.Text>
                    {Text({
                      tid: "SCHOOL_2026_INSTRUCTION_NOTE_3",
                      def: "SCHOOL_2026_INSTRUCTION_NOTE_3",
                    })}
                  </Typography.Text>
                </li>
                <li>
                  <Typography.Text>
                    {Text({
                      tid: "SCHOOL_2026_INSTRUCTION_NOTE_4",
                      def: "SCHOOL_2026_INSTRUCTION_NOTE_4",
                    })}
                  </Typography.Text>
                </li>
              </ol>
            </Col>
          </Row>
          {/* ELIGIBILITY CRITERIA*/}
          <Row className="section">
            <Col>
              <Typography.Title level={4}>
                {Text({
                  tid: "SCHOOL_2026_ELIGIBILITY_CRITERIA_HEADING",
                  def: "SCHOOL_2026_ELIGIBILITY_CRITERIA_HEADING",
                })}
              </Typography.Title>
              <Typography.Text>
                {Text({
                  tid: "SCHOOL_2026_ELIGIBILITY_CRITERIA",
                  def: "SCHOOL_2026_ELIGIBILITY_CRITERIA",
                })}
              </Typography.Text>
              <ol
                style={{
                  listStyleType:
                    userLanguage === "hi" || userLanguage === "sk"
                      ? "devanagari"
                      : "decimal",
                }}
              >
                <li>
                  <Typography.Text>
                    <b>
                      {Text({
                        tid: "SCHOOL_2026_ELIGIBILITY_CRITERIA_1_NOTE",
                        def: "SCHOOL_2026_ELIGIBILITY_CRITERIA_1_NOTE",
                      })}
                    </b>
                    {Text({
                      tid: "SCHOOL_2026_ELIGIBILITY_CRITERIA_1",
                      def: "SCHOOL_2026_ELIGIBILITY_CRITERIA_1",
                    })}
                  </Typography.Text>
                </li>
                <li>
                  <Typography.Text>
                    <b>
                      {Text({
                        tid: "SCHOOL_2026_ELIGIBILITY_CRITERIA_2_NOTE",
                        def: "SCHOOL_2026_ELIGIBILITY_CRITERIA_2_NOTE",
                      })}
                    </b>
                    {Text({
                      tid: "SCHOOL_2026_ELIGIBILITY_CRITERIA_2",
                      def: "SCHOOL_2026_ELIGIBILITY_CRITERIA_2",
                    })}
                  </Typography.Text>
                </li>
                <li>
                  <Typography.Text>
                    <b>
                      {Text({
                        tid: "SCHOOL_2026_ELIGIBILITY_CRITERIA_3_NOTE",
                        def: "SCHOOL_2026_ELIGIBILITY_CRITERIA_3_NOTE",
                      })}
                    </b>
                  </Typography.Text>

                  <ul
                    className="list-disc pl-6 mt-3 space-y-3"
                    style={{
                      listStyleType: "disc",
                      listStylePosition: "outside",
                    }}
                  >
                    <li>
                      <Typography.Text>
                        {Text({
                          tid: "SCHOOL_2026_ELIGIBILITY_CRITERIA_3",
                          def: "SCHOOL_2026_ELIGIBILITY_CRITERIA_3",
                        })}
                      </Typography.Text>
                    </li>

                    <li>
                      <Typography.Text>
                        {Text({
                          tid: "SCHOOL_2026_ELIGIBILITY_CRITERIA_4",
                          def: "SCHOOL_2026_ELIGIBILITY_CRITERIA_4",
                        })}
                      </Typography.Text>
                    </li>
                  </ul>
                </li>
                {/* <li>
                  <Typography.Text>
                    <b>
                      {Text({
                        tid: "SCHOOL_2026_ELIGIBILITY_CRITERIA_3_NOTE",
                        def: "SCHOOL_2026_ELIGIBILITY_CRITERIA_3_NOTE",
                      })}
                    </b>
                    {Text({
                      tid: "SCHOOL_ELIGIBILITY_CRITERIA_3",
                      def: "SCHOOL_ELIGIBILITY_CRITERIA_3",
                    })}
                  </Typography.Text>
                </li>
                <li>
                  <Typography.Text>
                    {Text({
                      tid: "SCHOOL_ELIGIBILITY_CRITERIA_4",
                      def: "SCHOOL_ELIGIBILITY_CRITERIA_4",
                    })}
                  </Typography.Text>
                </li> */}
                <li>
                  <Typography.Text>
                    <b>
                      {Text({
                        tid: "SCHOOL_2026_ELIGIBILITY_CRITERIA_5_NOTE",
                        def: "SCHOOL_2026_ELIGIBILITY_CRITERIA_5_NOTE",
                      })}
                    </b>
                    {Text({
                      tid: "SCHOOL_ELIGIBILITY_CRITERIA_5",
                      def: "SCHOOL_ELIGIBILITY_CRITERIA_5",
                    })}
                  </Typography.Text>
                </li>
              </ol>
            </Col>
          </Row>
          {/* Special Instructions */}
          <Row className="section">
            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
              <Typography.Title level={4}>
                {Text({
                  tid: "SCHOOL_2026_SPECIAL_INSTRUCTIONS_HEADING",
                  def: "SCHOOL_2026_SPECIAL_INSTRUCTIONS_HEADING",
                })}
              </Typography.Title>
              <ol
                style={{
                  listStyleType:
                    userLanguage === "hi" || userLanguage === "sk"
                      ? "devanagari"
                      : "decimal",
                }}
              >
                <li>
                  <Typography.Text>
                    {Text({
                      tid: "SCHOOL_2026_SPECIAL_INSTRUCTION_1",
                      def: "SCHOOL_2026_SPECIAL_INSTRUCTION_1",
                    })}
                  </Typography.Text>
                </li>
                <li>
                  <Typography.Text>
                    {Text({
                      tid: "SCHOOL_2026_SPECIAL_INSTRUCTION_2",
                      def: "SCHOOL_2026_SPECIAL_INSTRUCTION_2",
                    })}
                  </Typography.Text>
                </li>
                <li>
                  <Typography.Text>
                    {Text({
                      tid: "SCHOOL_2026_SPECIAL_INSTRUCTION_3",
                      def: "SCHOOL_2026_SPECIAL_INSTRUCTION_3",
                    })}
                  </Typography.Text>
                </li>
                <li>
                  <Typography.Text>
                    {Text({
                      tid: "SCHOOL_2026_SPECIAL_INSTRUCTION_4",
                      def: "SCHOOL_2026_SPECIAL_INSTRUCTION_4",
                    })}
                  </Typography.Text>
                </li>
                <li>
                  <Typography.Text>
                    {Text({
                      tid: "SCHOOL_2026_SPECIAL_INSTRUCTION_5",
                      def: "SCHOOL_2026_SPECIAL_INSTRUCTION_5",
                    })}
                  </Typography.Text>
                </li>
                {/* <li>
                  <Typography.Text>
                    {Text({
                      tid: "SCHOOL_SPECIAL_INSTRUCTION_7",
                      def: "SCHOOL_SPECIAL_INSTRUCTION_7",
                    })}
                  </Typography.Text>
                </li> */}
                <li>
                  <Typography.Text>
                    {Text({
                      tid: "SCHOOL_2026_SPECIAL_INSTRUCTION_6",
                      def: "SCHOOL_2026_SPECIAL_INSTRUCTION_6",
                    })}
                  </Typography.Text>

                  <ul
                    className="guidelineAdditionalDetailSection mt-3 space-y-3"
                    style={{
                      listStyleType: "disc",
                      listStylePosition: "outside",
                      paddingLeft: "28px",
                    }}
                  >
                    <li className="leading-8">
                      <div
                        dangerouslySetInnerHTML={{
                          __html:
                            SPECIAL_INSTRUCTION_6_OFFLINE_EMAIL_CONTENT_POST_COURIER,
                        }}
                      />
                    </li>

                    <li className="leading-8">
                      <div
                        dangerouslySetInnerHTML={{
                          __html: SPECIAL_INSTRUCTION_6_OFFLINE_EMAIL_CONTENT,
                        }}
                      />
                    </li>

                    <li className="leading-8">
                      <div
                        dangerouslySetInnerHTML={{
                          __html: SPECIAL_INSTRUCTION_6_OFFLINE_MOBILE,
                        }}
                      />
                    </li>
                  </ul>
                </li>
                {/* <li>
                    <div
                      dangerouslySetInnerHTML={{
                        __html: SPECIAL_INSTRUCTION_6_ONLINE_SCHOOL,
                      }}
                    ></div>
                  </li> */}
                {/* <li>
                  <Typography.Text>
                    {Text({
                      tid: "SCHOOL_SPECIAL_INSTRUCTION_6_OFFLINE",
                      def: "SCHOOL_SPECIAL_INSTRUCTION_6_OFFLINE",
                    })}
                  </Typography.Text>
                </li> */}
                {/* <div className="guidelineAdditionalDetailSection">
                  <li className="flex flex-row justify-start items-start">
                    <div
                      dangerouslySetInnerHTML={{
                        __html:
                          SPECIAL_INSTRUCTION_6_OFFLINE_EMAIL_CONTENT_POST_COURIER,
                      }}
                    ></div>
                  </li>
                  <li className="flex flex-row justify-start items-start ">
                    <div
                      dangerouslySetInnerHTML={{
                        __html: SPECIAL_INSTRUCTION_6_OFFLINE_EMAIL_CONTENT,
                      }}
                    ></div>
                  </li>
                  <li className="flex flex-row justify-start items-start">
                    <div
                      dangerouslySetInnerHTML={{
                        __html: SPECIAL_INSTRUCTION_6_OFFLINE_MOBILE,
                      }}
                    ></div>
                  </li>
                </div> */}
              </ol>
            </Col>
          </Row>
        </div>
      ) : userType === eUSER_FORM_TYPE.TEACHER ? (
        <div className=" mb-30">
          {/* Award Title and Guideline Heading */}
          <Row>
            <Col>
              <Typography.Title level={2}>
                {Text({
                  tid: "TEACHER_AWARD_TITLE",
                  def: "TEACHER_AWARD_TITLE",
                })}
              </Typography.Title>
              <Typography.Title level={3}>
                {Text({
                  tid: "TEACHER_2026_GUIDELINES_HEADING",
                  def: "TEACHER_2026_GUIDELINES_HEADING",
                })}
              </Typography.Title>
            </Col>
          </Row>
          {/* Application Window */}
          {timeLine[0]?.startDate &&
            timeLine[0]?.endDate &&
            timeLine[1]?.startDate &&
            timeLine[1]?.endDate && (
              <Row className="section">
                <Col>
                  <Typography.Title level={4}>
                    {Text({
                      tid: "TEACHER_APPLICATION_WINDOW",
                      def: "TEACHER_APPLICATION_WINDOW",
                    })}
                  </Typography.Title>
                  <ul>
                    <li>
                      <div
                        dangerouslySetInnerHTML={{
                          __html: APPLICATION_WINDOW_TEACHER_PART1,
                        }}
                      ></div>
                    </li>
                    <li>
                      <div
                        dangerouslySetInnerHTML={{
                          __html: APPLICATION_WINDOW_TEACHER_PART2,
                        }}
                      ></div>
                    </li>
                  </ul>
                </Col>
              </Row>
            )}
          {/* INSTRUCTION_NOTE */}
          <Row className="section">
            <Col>
              <Typography.Title level={4}>
                {Text({
                  tid: "TEACHER_2026_INSTRUCTION_NOTE_HEADING",
                  def: "TEACHER_2026_INSTRUCTION_NOTE_HEADING",
                })}
              </Typography.Title>
              <ol
                style={{
                  listStyleType:
                    userLanguage === "hi" || userLanguage === "sk"
                      ? "devanagari"
                      : "decimal",
                }}
              >
                <li>
                  <Typography.Text>
                    {Text({
                      tid: "TEACHER_2026_INSTRUCTION_NOTE_1",
                      def: "TEACHER_2026_INSTRUCTION_NOTE_1",
                    })}
                  </Typography.Text>
                </li>
                <li>
                  <Typography.Text>
                    {Text({
                      tid: "TEACHER_2026_INSTRUCTION_NOTE_2",
                      def: "TEACHER_2026_INSTRUCTION_NOTE_2",
                    })}
                  </Typography.Text>
                </li>
                <li>
                  <Typography.Text>
                    {Text({
                      tid: "TEACHER_2026_INSTRUCTION_NOTE_3",
                      def: "TEACHER_2026_INSTRUCTION_NOTE_3",
                    })}
                  </Typography.Text>
                </li>
                <li>
                  <Typography.Text>
                    {Text({
                      tid: "TEACHER_2026_INSTRUCTION_NOTE_4",
                      def: "TEACHER_2026_INSTRUCTION_NOTE_4",
                    })}
                  </Typography.Text>
                </li>
              </ol>
            </Col>
          </Row>
          {/* ELIGIBILITY CRITERIA*/}
          <Row className="section">
            <Col>
              <Typography.Title level={4}>
                {Text({
                  tid: "TEACHER_2026_ELIGIBILITY_CRITERIA_HEADING",
                  def: "TEACHER_2026_ELIGIBILITY_CRITERIA_HEADING",
                })}
              </Typography.Title>
              <Typography.Text>
                {Text({
                  tid: "TEACHER_2026_ELIGIBILITY_CRITERIA",
                  def: "TEACHER_2026_ELIGIBILITY_CRITERIA",
                })}
              </Typography.Text>
              <ol
                style={{
                  listStyleType:
                    userLanguage === "hi" || userLanguage === "sk"
                      ? "devanagari"
                      : "decimal",
                }}
              >
                <li>
                  <Typography.Text>
                    <b>
                      {Text({
                        tid: "TEACHER_2026_ELIGIBILITY_CRITERIA_1_TABLE_NOTE",
                        def: "TEACHER_2026_ELIGIBILITY_CRITERIA_1_TABLE_NOTE",
                      })}
                    </b>
                    {Text({
                      tid: "TEACHER_2026_ELIGIBILITY_CRITERIA_1",
                      def: "TEACHER_2026_ELIGIBILITY_CRITERIA_1",
                    })}
                  </Typography.Text>
                  <div className="mobileGuidelineTable">
                    <Table
                      columns={teacherGuideLineColumns}
                      dataSource={teacherGuideLineData}
                      style={{
                        marginBottom: "10px",
                        overflowX: "auto",
                      }}
                      pagination={false}
                    />
                  </div>
                </li>
                <li>
                  <Typography.Text>
                    <b>
                      {Text({
                        tid: "TEACHER_2026_ELIGIBILITY_CRITERIA_2_TABLE_NOTE",
                        def: "TEACHER_2026_ELIGIBILITY_CRITERIA_2_TABLE_NOTE",
                      })}
                    </b>
                    {Text({
                      tid: "TEACHER_2026_ELIGIBILITY_CRITERIA_2",
                      def: "TEACHER_2026_ELIGIBILITY_CRITERIA_2",
                    })}
                  </Typography.Text>
                </li>
                <li>
                  <Typography.Text>
                    <b>
                      {Text({
                        tid: "TEACHER_2026_ELIGIBILITY_CRITERIA_3_TABLE_NOTE",
                        def: "TEACHER_2026_ELIGIBILITY_CRITERIA_3_TABLE_NOTE",
                      })}
                    </b>
                    {Text({
                      tid: "TEACHER_2026_ELIGIBILITY_CRITERIA_3",
                      def: "TEACHER_2026_ELIGIBILITY_CRITERIA_3",
                    })}
                  </Typography.Text>
                </li>
                <li>
                  <Typography.Text>
                    <b>
                      {Text({
                        tid: "TEACHER_2026_ELIGIBILITY_CRITERIA_4_TABLE_NOTE",
                        def: "TEACHER_2026_ELIGIBILITY_CRITERIA_4_TABLE_NOTE",
                      })}
                    </b>
                    {Text({
                      tid: "TEACHER_2026_ELIGIBILITY_CRITERIA_4",
                      def: "TEACHER_2026_ELIGIBILITY_CRITERIA_4",
                    })}
                  </Typography.Text>
                </li>
                <li>
                  <Typography.Text>
                    <b>
                      {Text({
                        tid: "TEACHER_2026_ELIGIBILITY_CRITERIA_7_TABLE_NOTE",
                        def: "TEACHER_2026_ELIGIBILITY_CRITERIA_7_TABLE_NOTE",
                      })}
                    </b>
                    {Text({
                      tid: "TEACHER_2026_ELIGIBILITY_CRITERIA_7",
                      def: "TEACHER_2026_ELIGIBILITY_CRITERIA_7",
                    })}
                  </Typography.Text>
                </li>
                <li>
                  <Typography.Text>
                    <b>
                      {Text({
                        tid: "TEACHER_2026_ELIGIBILITY_CRITERIA_5_NOTE",
                        def: "TEACHER_2026_ELIGIBILITY_CRITERIA_5_NOTE",
                      })}
                    </b>
                    {Text({
                      tid: "TEACHER_2026_ELIGIBILITY_CRITERIA_5",
                      def: "TEACHER_2026_ELIGIBILITY_CRITERIA_5",
                    })}
                  </Typography.Text>
                </li>
                <li>
                  <Typography.Text>
                    <b>
                      {Text({
                        tid: "TEACHER_2026_ELIGIBILITY_CRITERIA_6_NOTE",
                        def: "TEACHER_2026_ELIGIBILITY_CRITERIA_6_NOTE",
                      })}
                    </b>
                    {Text({
                      tid: "TEACHER_2026_ELIGIBILITY_CRITERIA_6",
                      def: "TEACHER_2026_ELIGIBILITY_CRITERIA_6",
                    })}
                  </Typography.Text>
                </li>
              </ol>
            </Col>
          </Row>
          {/* Special Instructions */}
          <Row className="section">
            <Col>
              <Typography.Title level={4}>
                {Text({
                  tid: "TEACHER_2026_SPECIAL_INSTRUCTIONS_HEADING",
                  def: "TEACHER_2026_SPECIAL_INSTRUCTIONS_HEADING",
                })}
              </Typography.Title>
              <ol
                style={{
                  listStyleType:
                    userLanguage === "hi" || userLanguage === "sk"
                      ? "devanagari"
                      : "decimal",
                }}
              >
                <li>
                  <Typography.Text>
                    {Text({
                      tid: "TEACHER_2026_SPECIAL_INSTRUCTION_1",
                      def: "TEACHER_2026_SPECIAL_INSTRUCTION_1",
                    })}
                  </Typography.Text>
                </li>
                <li>
                  <Typography.Text>
                    {Text({
                      tid: "TEACHER_2026_SPECIAL_INSTRUCTION_2",
                      def: "TEACHER_2026_SPECIAL_INSTRUCTION_2",
                    })}
                  </Typography.Text>
                </li>
                <li>
                  <Typography.Text>
                    {Text({
                      tid: "TEACHER_2026_SPECIAL_INSTRUCTION_3",
                      def: "TEACHER_2026_SPECIAL_INSTRUCTION_3",
                    })}
                  </Typography.Text>
                </li>
                <li>
                  <Typography.Text>
                    {Text({
                      tid: "TEACHER_2026_SPECIAL_INSTRUCTION_4",
                      def: "TEACHER_2026_SPECIAL_INSTRUCTION_4",
                    })}
                  </Typography.Text>
                </li>
                <li>
                  <Typography.Text>
                    {Text({
                      tid: "TEACHER_2026_SPECIAL_INSTRUCTION_5",
                      def: "TEACHER_2026_SPECIAL_INSTRUCTION_5",
                    })}
                  </Typography.Text>
                </li>
                {/* <li>
                  <Typography.Text>
                    {Text({
                      tid: "TEACHER_SPECIAL_INSTRUCTION_7",
                      def: "TEACHER_SPECIAL_INSTRUCTION_7",
                    })}
                  </Typography.Text>
                </li> */}
                <li>
                  <Typography.Text>
                    {Text({
                      tid: "TEACHER_2026_SPECIAL_INSTRUCTION_6",
                      def: "TEACHER_2026_SPECIAL_INSTRUCTION_6",
                    })}
                  </Typography.Text>

                  <ul
                    className="guidelineAdditionalDetailSection mt-3 space-y-3"
                    style={{
                      listStyleType: "disc",
                      listStylePosition: "outside",
                      paddingLeft: "28px",
                    }}
                  >
                    <li className="leading-8">
                      <div
                        dangerouslySetInnerHTML={{
                          __html:
                            SPECIAL_INSTRUCTION_6_OFFLINE_EMAIL_CONTENT_POST_COURIER,
                        }}
                      />
                    </li>

                    <li className="leading-8">
                      <div
                        dangerouslySetInnerHTML={{
                          __html: SPECIAL_INSTRUCTION_6_OFFLINE_EMAIL_CONTENT,
                        }}
                      />
                    </li>

                    <li className="leading-8">
                      <div
                        dangerouslySetInnerHTML={{
                          __html: SPECIAL_INSTRUCTION_6_OFFLINE_MOBILE,
                        }}
                      />
                    </li>
                  </ul>
                </li>
                {/* <li>
                  <div
                    dangerouslySetInnerHTML={{
                      __html: SPECIAL_INSTRUCTION_6_ONLINE_TEACHER,
                    }}
                  ></div>
                </li> */}

                {/* <Typography.Text>
                    {Text({
                      tid: "TEACHER_SPECIAL_INSTRUCTION_6_OFFLINE",
                      def: "TEACHER_SPECIAL_INSTRUCTION_6_OFFLINE",
                    })}
                  </Typography.Text> */}
                {/* <div className="guidelineAdditionalDetailSection">
                  <li className="flex flex-row justify-start items-start">
                    <div
                      dangerouslySetInnerHTML={{
                        __html:
                          SPECIAL_INSTRUCTION_6_OFFLINE_EMAIL_CONTENT_POST_COURIER,
                      }}
                    ></div>
                  </li>
                  <li className="flex flex-row justify-start items-start">
                    <div
                      dangerouslySetInnerHTML={{
                        __html: SPECIAL_INSTRUCTION_6_OFFLINE_EMAIL_CONTENT,
                      }}
                    ></div>
                  </li>
                  <li className="flex flex-row justify-start items-start">
                    <div
                      dangerouslySetInnerHTML={{
                        __html: SPECIAL_INSTRUCTION_6_OFFLINE_MOBILE,
                      }}
                    ></div>
                  </li>
                </div> */}
              </ol>
            </Col>
          </Row>
        </div>
      ) : null}
    </div>
  );
};

export default DashboardGuideline;
